// The way out of a dead-end page (not found, module unavailable): a button into the
// landing module, and the menu hint only when the header actually has a menu. With one
// available module there is none, and "use the menu at the top left" pointed at nothing.
// `help` is module-logic.js's deadEndHelp(), decided in Shell.jsx.
// The shell must not import the kit barrel: the kit and React Aria belong in module chunks.
import { Link } from 'react-router';

export default function DeadEndWayOut({ help }) {
  const { landing, menuHint } = help;
  return (
    <>
      {menuHint && (
        <p className="mt-2 text-sm text-ink-secondary">Use the menu at the top left to open a module you can use.</p>
      )}
      {landing && <Link to={landing.home} className="btn-primary mt-4 inline-block">Go to {landing.label}</Link>}
    </>
  );
}
